<div class="mfa-challenge text-center">
  <h2 class="mfa-title">Two-factor verification</h2>

  <p class="instructions">
    Your account is protected with two-factor authentication. Verify your
    identity to finish signing in.
  </p>

  <!-- Invisible reCAPTCHA anchor for SMS challenges -->
  <div id="mfa-recaptcha-container"></div>

  @if (infoMessage) {
    <div class="success-message" role="status">{{ infoMessage }}</div>
  }

  @if (errorMessage) {
    <div class="server-error" role="alert">{{ errorMessage }}</div>
  }

  <!-- Factor selection (when the account has more than one factor) -->
  @if (!selectedHint && hints.length > 0) {
    <div class="d-grid gap-2 mt-3">
      @for (hint of hints; track hint.uid) {
        <button
          type="button"
          class="btn btn-primary btn-fill"
          (click)="selectHint(hint)"
          [disabled]="loading"
        >
          {{ hintLabel(hint) }}
        </button>
      }
    </div>
  }

  @if (selectedHint) {
    <p class="factor-label">
      Using: <strong>{{ hintLabel(selectedHint) }}</strong>
    </p>

    <!-- Phone factor: send the SMS code first -->
    @if (selectedHint.factorId === phoneFactorId && !smsSent) {
      <div class="d-grid gap-2 mt-3">
        <button
          type="button"
          class="btn btn-primary btn-fill"
          (click)="sendSmsCode()"
          [disabled]="loading"
        >
          @if (loading) {
            Sending code...
          } @else {
            Send verification code
          }
        </button>
      </div>
    }

    <!-- Code entry (SMS after send, TOTP immediately) -->
    @if (selectedHint.factorId === totpFactorId || smsSent) {
      <form class="code-form mt-3" (ngSubmit)="submitCode()">
        <label class="form-label" for="mfaCode">
          @if (selectedHint.factorId === phoneFactorId) {
            Enter the 6-digit code we sent to your phone
          } @else {
            Enter the 6-digit code from your authenticator app
          }
        </label>
        <input
          id="mfaCode"
          class="form-control code-input text-center"
          type="text"
          inputmode="numeric"
          autocomplete="one-time-code"
          maxlength="6"
          placeholder="123456"
          [formControl]="codeControl"
        />
        @if (
          codeControl.invalid && (codeControl.dirty || codeControl.touched)
        ) {
          <div class="server-error" role="alert">
            Enter the 6-digit verification code.
          </div>
        }

        <div class="d-grid gap-2 mt-3">
          <button
            type="submit"
            class="btn btn-primary btn-fill btn-danger"
            [disabled]="loading || codeControl.invalid"
          >
            @if (loading) {
              Verifying...
            } @else {
              Verify and continue
            }
          </button>

          @if (selectedHint.factorId === phoneFactorId) {
            <button
              type="button"
              class="btn btn-primary btn-sm btn-fill"
              (click)="sendSmsCode()"
              [disabled]="loading"
            >
              Resend code
            </button>
          }
        </div>
      </form>
    }

    <!-- Switch factor when several are enrolled -->
    @if (hints.length > 1) {
      <button
        type="button"
        class="btn btn-link switch-link"
        (click)="selectedHint = null"
        [disabled]="loading"
      >
        Use a different method
      </button>
    }
  }

  <button
    type="button"
    class="btn btn-link back-link"
    (click)="backToLogin()"
  >
    Back to sign in
  </button>
</div>
